import React from 'react'
import { Box, PageContainerMain } from '../../Components/Layout'
import { TransactionsTabs } from './TransactionsTabs'
import { HeadXL } from '../../Components/Typography/Text.styles'
import { AdUnit } from '../../Components/Ads/AdUnit'

const Transactions: React.FC<React.PropsWithChildren<unknown>> = () => {

  return (
    <>
      <PageContainerMain>
        <Box noMargin>
          <AdUnit bannerType="bannerMain" aria-label="Transactions page ad" />
          <HeadXL sideMargins={2}>League Transactions Database</HeadXL>
          <TransactionsTabs />
          <AdUnit bannerType="bannerSecond" bottomFixed aria-label="Transactions page ad second" />
        </Box>
      </PageContainerMain>
    </>
  )
}

export default Transactions
